const imgFilter = (value, size) => {
  return `${value}?x-oss-process=image/resize,m_lfit,h_${size},w_${size}`
}

export default imgFilter
